import { removeLastIssue, setCurrentCarouselItemToPrevious } from 'actions';
import { CarouselBackButton } from 'components/CarouselBackButton';
import { Phrase } from 'components/Phrase';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import {
  CarouselReduxReducer,
  ICarouselItemIssueDetailsTopProps,
} from 'typings';

import { Header } from './styles';

export const CarouselItemIssueDetailsTop = ({
  issueStackItem: {
    issue: {
      isEmergency,
      specifier: {
        details: { notice },
        title,
      },
    },
  },
}: ICarouselItemIssueDetailsTopProps) => {
  const dispatch = useThunkDispatch();

  const handleClick = () => {
    dispatch(setCurrentCarouselItemToPrevious(CarouselReduxReducer.SERVICE));

    setTimeout(() => {
      dispatch(removeLastIssue());
    }, 500);
  };

  let defaultHeader = Phrase({ id: 'ISSUE_DETAILS.DEFAULT.HEADER' });

  if (notice) {
    defaultHeader = isEmergency
      ? Phrase({ id: 'ISSUE_DETAILS.EMERGENCY.HEADER' })
      : Phrase({ id: 'ISSUE_DETAILS.NOTICE.HEADER' });
  }

  return (
    <>
      <CarouselBackButton onClick={handleClick} />
      <Header>{title || defaultHeader}</Header>
    </>
  );
};
